
import './jquery';
import 'popper.js';
import 'bootstrap';

import 'bootstrap/dist/css/bootstrap.css'
import '@fortawesome/fontawesome-free/css/all.css';

import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';

import '../css/style.css';
import '../css/responsive.css';
import '../css/typography.css';

document.querySelectorAll('[data-current-year]').forEach((year) => {
  year.textContent = new Date().getFullYear();
});

const anchoredSections = Array.from(document.querySelectorAll('section[id]'));
let sectionHashUpdateQueued = false;

function updateSectionHash() {
  sectionHashUpdateQueued = false;

  const header = document.querySelector('.fixed-top');
  const headerHeight = header ? header.offsetHeight : 0;
  const readingLine = window.scrollY + headerHeight + (window.innerHeight * 0.25);
  let currentSection = 'home';

  anchoredSections.forEach((section) => {
    if (section.offsetTop <= readingLine) {
      currentSection = section.id;
    }
  });

  const currentHash = window.location.hash;
  const isServiceTopic = currentHash.indexOf('#how-can-i-help-') === 0;

  if (currentSection === 'how-can-i-help' && isServiceTopic) return;

  const nextHash = '#' + currentSection;
  if (currentHash === nextHash) return;

  const historyMethod = isServiceTopic ? 'pushState' : 'replaceState';
  window.history[historyMethod](window.history.state, '', nextHash);
}

window.addEventListener('scroll', () => {
  if (sectionHashUpdateQueued) return;
  sectionHashUpdateQueued = true;
  window.requestAnimationFrame(updateSectionHash);
}, { passive: true });

const swiper = new Swiper(".mySwiper", {
    loop: false,
    spaceBetween: 10,
    slidesPerView: 3,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
});

new Swiper(".mySwiper2", {
    loop: false,
    spaceBetween: 10,
     
    thumbs: {
        swiper: swiper,
    },
});

$(function () {
    $('.navbar-nav .nav-link').click(function () {
      if (window.matchMedia('(max-width: 991px)').matches) {
        $('#navbarSupportedContent').collapse('hide');
      }
    });

    $('.services-box').click(function () {

      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $('#service_description').hide();
        $('#service_description').html('');
        return;
      }
      $('.services-box').removeClass('active');
      $(this).addClass('active');
      var content = $(this).find('.service-box-text').html();
      $('#service_description').html(content);
      $('#service_description').show();

      if ((window.innerHeight + window.scrollY) < ($('#service_description').offset().top + 50)) {
        $(window).scrollTop($('#service_description').offset().top - 200);
      }
    });

    // $(window).on('activate.bs.scrollspy', function (e, o) {
    //   let path = o.relatedTarget.replace(/#/, '');
    //   console.log("This event is not firing...");
    // });
  });
